function HomeRetrieveSavedQuoteResponseTransformer($filter, jsonMapper, Util) {
	// transform functions
	var transformers = {
		camelcase: function(value) {
			if (value) {
				return value.charAt(0).toUpperCase() + value.slice(1);
			}
		},
		date: function(dateString) {
			var date = moment(dateString, 'YYYY-MM-DD');
			return date.format('DD/MM/YYYY');
		},
		today: function(dateString) {
			var returnDate = '';
			if (moment().diff(dateString, 'days') > 0) {
				var date = moment();
				returnDate = date.format('DD/MM/YYYY');
			} else {
				var date = moment(dateString, 'YYYY-MM-DD');
				returnDate = date.format('DD/MM/YYYY');
			}
			return returnDate;
		},
		hasValue: function(value) {
			if (value) {
				return true;
			} else {
				return false;
			}
		},
		financeType: function(financeType) {
			switch (financeType) {
				case 'none':
					return '';
					break;
			}
		},
		convertGender: function(gender) {
			var gc = {
				M: 'male',
				F: 'female',
				I: 'intersex'
			};
			return gc[gender];
		},
		yesNo: function(value) {
			return value == 'yes' ? true : false;
		},
		checkbox: function(value) {},
		state: function(state) {
			if (state) return state.replace('AU_', '');
		},
		coverType: function(coverType) {
			if (
				coverType === 'third_party' ||
				coverType === 'third_party_fire_theft'
			) {
				return 'third_party';
			}
			return coverType;
		},
		purchaseMonthFromMonthYear: function(monthYear) {
			if (monthYear) {
				return monthYear.split('-')[1];
			} else {
				return '';
			}
		},
		purchaseYearFromMonthYear: function(monthYear) {
			if (monthYear) {
				return monthYear.split('-')[0];
			} else {
				return '';
			}
		},
		thirdPartyPref: function(coverType) {
			if (coverType === 'comprehensive') {
				return null;
			}
			return coverType;
		},
		itemCount: function(itemString) {
			var itemObj = {
				no_balconies_or_decks: '0',
				no_verandahs: '0',
				'0_item': '0',
				'1_item': '1',
				'2_items': '2',
				'3_items': '3',
				'4_items': '4',
				'5_items': '5',
				'6_items': '6',
				'7_items': '7',
				'8_items': '8',
				'9_items': '9',
				'10_items': '10',
				'11_items': '11'
			};

			return itemObj[itemString];
		},
		itemCountGarages: function(itemString) {
			var itemObj = {
				no_garages: '0',
				garage_for_1_car: '1',
				garage_for_2_cars: '2',
				garage_for_3_cars: '3',
				garage_for_4_cars: '4',
				garage_for_5_cars: '5',
				garage_for_6_cars: '6'
			};

			return itemObj[itemString];
		},
		itemCountCarPort: function(itemString) {
			var itemObj = {
				no_carports: '0',
				carport_for_1_car: '1',
				carport_for_2_cars: '2',
				carport_for_3_cars: '3',
				carport_for_4_cars: '4',
				carport_for_5_cars: '5',
				carport_for_6_cars: '6'
			};

			return itemObj[itemString];
		},
		cycleNameMapping: function(itemString) {
			var itemObj = {
				mountain_bike: 'Mountain Bike',
				road_bike: 'Road Bike',
				bmx: 'BMX',
				track_bike: 'Track Bike',
				motorised_bike: 'Motorised Bike',
				accessories: 'Accessories',
				custom_parts: 'Custom parts',
				travel_case: 'Travel case',
				cycling_apparel: 'Cycling Apparel',
				cycling_computer: 'Cycling Computer'
			};

			return itemObj[itemString];
		},
		coverMapping: function(itemString) {
			var itemObj = {
				building_only: 'Building only',
				contents_only: 'Contents only',
				building_and_contents: 'Building and Contents',
				multi_item_loss: 'Multi Item Loss',
				bicycle: 'Bicycle',
				camping_equipment: 'Camping Equipment',
				clothing: 'Clothing',
				collection: 'Collection',
				computer_equipment: 'Computer Equipment',
				eye_ware: 'Eye ware',
				firearm: 'Firearm',
				gps_device: 'GPS Device',
				hearing_aid: 'Hearing Aid',
				in_vault_item: 'In Vault Item',
				jewellery: 'Jewellery',
				mobile_phone: 'Mobile Phone',
				music_games_media: 'Music, Games and Media',
				personal_medical_item: 'Personal Medical Item',
				personal_valuable_item: 'Personal Valuable Item',
				photographic_equipment: 'Photographic and Video Equipment',
				portable_music_instrument: 'Portable musical instrument',
				prosthetics: 'Prosthetics',
				other_portable_item: 'Other Portable Item',
				sporting_equipment: 'Sporting Equipment',
				tablet: 'Portable Computer Equipment',
				watch: 'Watch'
			};

			return itemObj[itemString];
		},
		monthFromNumber: function(monthNumber) {
			var monthObj = {
				'01': 'January',
				'02': 'February',
				'03': 'March',
				'04': 'April',
				'05': 'May',
				'06': 'June',
				'07': 'July',
				'08': 'August',
				'09': 'September',
				'10': 'October',
				'11': 'November',
				'12': 'December'
			};

			return monthObj[monthNumber];
		}
	};

	function transformBuilding(buildingDetails) {
		var slope = buildingDetails.landSlope;
		if (slope === 'flat') {
			buildingDetails.landSlope = 'flat';
		} else {
			buildingDetails.landSlope = buildingDetails.slopeType;
		}
		return buildingDetails;
	}

	function transformTellUsAboutBuilding(buildingDetails) {
		if (buildingDetails.isHomeElevated) {
		} else {
			buildingDetails.isHomeElevated = 'notasked';
		}
		return buildingDetails;
	}

	function transformInsuranceHistory(insuranceHistory) {
		var _portableClaimHistory = [];
		var _claimHistory = [];

		if (insuranceHistory.history) {
			insuranceHistory.history.forEach(function(item) {
				if (item.isPortableContents) {
					_portableClaimHistory.push({
						coverAffected: {
							value: item.contentCategory,
							label: transformers.coverMapping(
								item.contentCategory
							)
						},
						year: {
							value: item.year,
							label: item.year
						},
						month: {
							value: transformers.monthFromNumber(
								item.eventMonth
							),
							label: transformers.monthFromNumber(item.eventMonth)
						},
						description: {
							value: item.pattern.description,
							label: item.pattern.description,
							description: item.pattern.description,
							publicID: item.pattern.publicID,
							code: item.pattern.code,
							filter1: item.pattern.filter1
						}
					});
				} else {
					_claimHistory.push({
						coverAffected: {
							value: item.claimType,
							label: transformers.coverMapping(item.claimType)
						},
						year: {
							value: item.year,
							label: item.year
						},
						month: {
							value: transformers.monthFromNumber(
								item.eventMonth
							),
							label: transformers.monthFromNumber(item.eventMonth)
						},
						description: {
							value: item.pattern.description,
							label: item.pattern.description,
							description: item.pattern.description,
							publicID: item.pattern.publicID,
							code: item.pattern.code,
							filter1: item.pattern.filter1
						}
					});
				}
			});

			insuranceHistory.claimDetails = _claimHistory;
			insuranceHistory.portableClaimDetails = _portableClaimHistory;
		}

		return insuranceHistory;
	}

	function transformCycleCover(cycleCover) {
		var _cycleList = [];
		var _coverItemsList = [];
		if (cycleCover.cycleList) {
			cycleCover.cycleList.forEach(function(item) {
				_cycleList.push({
					bikeType: {
						value: item.typeOfBicycle,
						label: transformers.cycleNameMapping(item.typeOfBicycle)
					},
					description: item.description,
					value: item.value
				});
			});
		}

		if (cycleCover.coverItemsList) {
			cycleCover.coverItemsList.forEach(function(item) {
				_coverItemsList.push({
					category: {
						value: item.category,
						label: transformers.cycleNameMapping(item.category)
					},
					description: item.description,
					value: item.value
				});
			});
		}

		if (_coverItemsList.length > 0) {
			cycleCover.coverItems = true;
		} else {
			cycleCover.coverItems = false;
		}

		cycleCover.cycleList = _cycleList;
		cycleCover.coverItemsList = _coverItemsList;
		// {"bikeType":{"value":"mountain_bike","label":"Mountain Bike"},"description":"mb","value":"1000"}
		return cycleCover;
	}

	function transformMortgageOnProperty(mortgageOnProperty) {
		if (
			mortgageOnProperty.propertyMortgagedWith &&
			mortgageOnProperty.propertyMortgagedWith.length > 0
		) {
			mortgageOnProperty.isPropertyUnderMortgage = true;
			var _mortgageWith = [];
			mortgageOnProperty.propertyMortgagedWith.forEach(function(item) {
				_mortgageWith.push(item.mortgagee);
			});

			mortgageOnProperty.propertyMortgagedWith = _mortgageWith;
		} else {
			mortgageOnProperty.isPropertyUnderMortgage = false;
			mortgageOnProperty.propertyMortgagedWith = [];
		}
		return mortgageOnProperty;
	}

	function transformSecurity(securityTransform) {
		var _securityExternalDoors = {
			deadlocks: securityTransform.security.hasDoorDeadlocks == 'yes',
			door_security_screen:
				securityTransform.security.hasDoorSecurityScreen == 'yes'
		};

		var _securityExternalWindows = {
			keylocks: securityTransform.security.hasWindowKeylocks == 'yes',
			roller_shutter:
				securityTransform.security.hasWindowRollerShutter == 'yes',
			security_screens_or_bars:
				securityTransform.security.hasWindowScreenBars == 'yes'
		};

		var _otherSecurity = {
			gated_community:
				securityTransform.security.isGatedCommunity == 'yes',
			'24_hour_concierge':
				securityTransform.security.has24HourConcierge == 'yes',
			fixed_home_sage:
				securityTransform.security.hasFixedHomeSafe == 'yes',
			security_rated_building:
				securityTransform.security.isSecurityRatedBuilding == 'yes',
			'24_hour_monitored_alarm':
				securityTransform.security.haveSecurityAlarm == 'yes'
		};

		return {
			securityExternalDoors: _securityExternalDoors,
			securityExternalWindows: _securityExternalWindows,
			otherSecurity: _otherSecurity
		};
	}

	function transformNeeds(needTransform, fullData) {
		var coverType = needTransform.coverType;
		needTransform.coverNeeds = {
			building: false,
			contents: false,
			rent_default: false,
			malicious_damage: false
		};

		//basic need
		if (coverType == 'building_and_contents') {
			needTransform.coverNeeds.building = true;
			needTransform.coverNeeds.contents = true;
		} else if (coverType == 'building_only') {
			needTransform.coverNeeds.building = true;
		} else if (coverType == 'contents_only') {
			needTransform.coverNeeds.contents = true;
		}

		//landlord needs
		var policyOption = needTransform.policyOption;
		if (policyOption.isRentDefaultCover) {
			needTransform.coverNeeds.rent_default = true;
		}

		if (fullData.theftAndVandalismByTenants) {
			if (
				fullData.theftAndVandalismByTenants.theftCoverContents ||
				fullData.theftAndVandalismByTenants.theftCoverBuilding
			) {
				needTransform.coverNeeds.malicious_damage = true;
			}
		}

		delete needTransform.policyOption;
		delete needTransform.coverType;

		return needTransform;
	}

	function transformMainPolicyHolder(returnObject, policyHolder, response) {
		//tell us about the main policy holder -------------------------------------
		returnObject.mainPolicyHolder = {
			prefix: policyHolder.contact.prefix,
			firstName: policyHolder.contact.firstName,
			lastName: policyHolder.contact.lastName,
			gender: policyHolder.contact.gender,
			dateOfBirth: policyHolder.contact.dateOfBirth,
			tenYears_chargedOrConvictedOffences:
				policyHolder.contact.hasConviction
		};
		convertMapping = {
			'mainPolicyHolder.gender': transformers.convertGender,
			'mainPolicyHolder.dateOfBirth': transformers.date
		};

		var mappedValue = jsonMapper.convert(returnObject, convertMapping);
		if (policyHolder.contact.hasConviction == 'yes') {
			//parse dwelling history only if the hasConviction is yes
			var _convictionHistory = [];
			policyHolder.contact.dwellingHistory.forEach(function(conviction) {
				// tenYears_chargedOrConvictedOffences

				var _conviction = {
					description: {
						publicID: conviction.pattern.publicID,
						code: conviction.pattern.code,
						description: conviction.pattern.description,
						value: conviction.pattern.description,
						label: conviction.pattern.description,
						filter1: conviction.pattern.filter1
					},
					year: {
						label: conviction.year,
						value: conviction.year
					},
					month: {
						label: transformers.monthFromNumber(
							conviction.eventMonth
						),
						value: transformers.monthFromNumber(
							conviction.eventMonth
						)
					}
				};
				_convictionHistory.push(_conviction);
			});

			returnObject.mainPolicyHolder.tenYears_chargedOrConvictedOffencesDetails = _convictionHistory;
		}

		//main policy holder contact -------------------------------------
		returnObject.mainPolicyHolderContact = {
			personContactResidentialAddress:
				policyHolder.contact.primaryAddress,
			address: policyHolder.contact.primaryAddress,
			//::'personContactSamePostalAddress' : policyHolder.contact,
			// 'personContactPostalAddress' : policyHolder.contact,
			emailAddress1: policyHolder.contact.emailAddress1,
			primaryPhone: policyHolder.contact.primaryPhone,
			passwordQuestion: policyHolder.contact.passwordQuestion,
			// 'personContactEnterAQuestion' : policyHolder.contact,
			passwordAnswer: policyHolder.contact.passwordAnswer,
			personContactMailingPreference: response.documentDeliveryMethod
		};

		//add number based on phone type
		if (policyHolder.contact.primaryPhone === 'work') {
			returnObject.mainPolicyHolderContact.contactNumber =
				policyHolder.contact.workPhone;
		} else if (policyHolder.contact.primaryPhone === 'home') {
			returnObject.mainPolicyHolderContact.contactNumber =
				policyHolder.contact.homePhone;
		} else if (policyHolder.contact.primaryPhone === 'mobile') {
			returnObject.mainPolicyHolderContact.contactNumber =
				policyHolder.contact.cellPhone;
		}

		//if custom question
		if (
			policyHolder.contact.passwordQuestion ===
			'customer_created_question'
		) {
			returnObject.mainPolicyHolderContact.personContactEnterAQuestion =
				policyHolder.contact.passwordQuestionStr;
		}

		// if contact type is company
		if (policyHolder.contact.contactType === 'company') {
			var authorisedPerson =
				policyHolder.contact.authorisedPersons[0].person;
			returnObject.aboutTheCompany = {};
			returnObject.aboutTheCompany.name = policyHolder.contact.name;
			returnObject.aboutTheCompany.abn = policyHolder.contact.abn;
			returnObject.aboutTheCompany.emailAddress1 =
				policyHolder.contact.emailAddress1;
			returnObject.aboutTheCompany.workPhone =
				policyHolder.contact.workPhone;
			returnObject.aboutTheCompany.companyAddress =
				policyHolder.contact.primaryAddress;

			returnObject.aboutCompanyContact = {};
			returnObject.aboutCompanyContact.prefix = authorisedPerson.prefix;
			returnObject.aboutCompanyContact.firstName =
				authorisedPerson.firstName;
			returnObject.aboutCompanyContact.lastName =
				authorisedPerson.lastName;
			returnObject.aboutCompanyContact.gender = transformers.convertGender(
				authorisedPerson.gender
			);
			returnObject.aboutCompanyContact.dateOfBirth = transformers.date(
				authorisedPerson.dateOfBirth
			);

			// postal address and custom question is not saved in GW
			returnObject.companyContactContact = {};
			returnObject.companyContactContact.companyContactResidentialAddress =
				authorisedPerson.primaryAddress;
			returnObject.companyContactContact.emailAddress1 =
				authorisedPerson.emailAddress1;
			// returnObject.companyContactContact.companyContactDetailsPostalAddress = response.policyAddress;
			returnObject.companyContactContact.primaryPhone =
				authorisedPerson.primaryPhone;
			returnObject.companyContactContact.contactNumber =
				authorisedPerson.homePhone ||
				authorisedPerson.workPhone ||
				authorisedPerson.cellPhone;
			returnObject.companyContactContact.passwordQuestion =
				policyHolder.contact.passwordQuestion;
			// returnObject.companyContactContact.passwordQuestionStr = policyHolder.contact.passwordQuestionStr || '';
			returnObject.companyContactContact.passwordAnswer =
				policyHolder.contact.passwordAnswer;
			returnObject.companyContactContact.companyContactMailingPreference =
				response.documentDeliveryMethod;
		}

		return returnObject;
	}

	//transform for the other policy holder
	function transformOtherPolicyHolder(returnObject, policyHolder) {
		if (!returnObject.additionalPolicyHolders) {
			returnObject.additionalPolicyHolders = {};
		}

		if (!returnObject.additionalPolicyHolders.policyHolders) {
			returnObject.additionalPolicyHolders.policyHolders = [];
		}

		var _contact = {
			additionalContactSamePostalAddress: 'yes',
			address: policyHolder.contact.primaryAddress,
			contactNumber: '',
			dateOfBirth: policyHolder.contact.dateOfBirth,
			emailAddress1: policyHolder.contact.emailAddress1,
			firstName: policyHolder.contact.firstName,
			gender: policyHolder.contact.gender,
			lastName: policyHolder.contact.lastName,
			passwordAnswer: policyHolder.contact.passwordAnswer,
			passwordQuestion: policyHolder.contact.passwordQuestion,
			prefix: policyHolder.contact.prefix,
			primaryPhone: policyHolder.contact.primaryPhone
			// 'tenYears_chargedOrConvictedOffences':policyHolder.,
			// 'tenYears_chargedOrConvictedOffencesDetails':policyHolder.,
		};

		//add number based on phone type
		if (policyHolder.contact.primaryPhone === 'work') {
			_contact.contactNumber = policyHolder.contact.workPhone;
		} else if (policyHolder.contact.primaryPhone === 'home') {
			_contact.contactNumber = policyHolder.contact.homePhone;
		} else if (policyHolder.contact.primaryPhone === 'mobile') {
			_contact.contactNumber = policyHolder.contact.cellPhone;
		}

		//if custom question
		if (
			policyHolder.contact.passwordQuestion ===
			'customer_created_question'
		) {
			_contact.personContactEnterAQuestion =
				policyHolder.contact.passwordQuestionStr;
		}

		if (policyHolder.contact.hasConviction === 'yes') {
			_contact.tenYears_chargedOrConvictedOffences = 'yes';
			_contact.tenYears_chargedOrConvictedOffencesDetails = [];
			policyHolder.contact.dwellingHistory.forEach(function(history) {
				_contact.tenYears_chargedOrConvictedOffencesDetails.push({
					description: {
						publicID: history.pattern.publicID,
						code: history.pattern.code,
						description: history.pattern.description,
						value: history.pattern.description,
						label: history.pattern.description,
						filter1: history.pattern.filter1
					},
					year: {
						label: history.year,
						value: history.year
					},
					month: {
						label: transformers.monthFromNumber(history.eventMonth),
						value: transformers.monthFromNumber(history.eventMonth)
					}
				});
			});
		} else {
			_contact.tenYears_chargedOrConvictedOffences = 'no';
		}

		convertMapping = {
			gender: transformers.convertGender,
			dateOfBirth: transformers.date
		};

		var mappedValue = jsonMapper.convert(_contact, convertMapping);
		returnObject.additionalPolicyHolders.policyHolders.push(_contact);

		return returnObject;
	}

	//transform policy holders
	function transformPolicyHolders(returnObject, response) {
		var _policyHolders = returnObject.policyHolders;
		var _policyHolderOldestDOB = moment();
		_policyHolders.forEach(function(policyHolder) {
			if (policyHolder.mainHolder == true) {
				returnObject = transformMainPolicyHolder(
					returnObject,
					policyHolder,
					response
				);
			} else {
				returnObject = transformOtherPolicyHolder(
					returnObject,
					policyHolder
				);
			}
			//sets as oldest date of birth if higher
			if (
				_policyHolderOldestDOB.diff(
					policyHolder.contact.dateOfBirth,
					'days'
				) > 0
			) {
				_policyHolderOldestDOB = moment(
					policyHolder.contact.dateOfBirth
				);
			}
		});

		// sets the oldest persons date of birth
		returnObject.tellUsAboutInsured.dobOldestInsured = _policyHolderOldestDOB.format(
			'DD/MM/YYYY'
		);

		return returnObject;
	}

	/**
	 * Transforms the retrievedQuoteRepsonse into a format that can be injected into the userInputRepository
	 * The returned value will populate all the forms in the quote process
	 * @param {Object} retrievedQuoteResponse				   Response object from the retrieveSavedQuote service
	 * @returns {Object}										Transformed object ready to inject into the userInputRepository
	 */
	function transform(retrievedQuoteResponse) {
		console.info('retrievedQuoteResponse', retrievedQuoteResponse);

		var transformMapping = {
				//estimate =================================================
				//tell us about property -------------------------------------
				'returnObject.tellUsAboutTheProperty.address':
					'=_input.dwellings.0.location',
				'returnObject.tellUsAboutTheProperty.typeOfBuilding':
					'=_input.dwellings.0.buildingType',
				'returnObject.tellUsAboutTheProperty.wallsMadeOf':
					'=_input.dwellings.0.externalWallMaterial',
				'returnObject.tellUsAboutTheProperty.howIsHomeOccupied':
					'=_input.dwellings.0.homeOccupancy',
				'returnObject.tellUsAboutTheProperty.propertyProfessionalAgent':
					'=_input.dwellings.0.policyOption.isPropertyAgentManaged',

				//tell us how we can insure you -------------------------------------
				'returnObject.tellUsHowWeCanInsureYou.coverType':
					'=_input.dwellings.0.coverType',
				'returnObject.tellUsHowWeCanInsureYou.policyOption':
					'=_input.dwellings.0.policyOption',
				'returnObject.tellUsHowWeCanInsureYou.needCoverOutsideHome':
					'=_input.dwellings.0.hasPortableContentsHomeAway',

				//rapid estimate -------------------------------------

				//tell us a bit more -------------------------------------
				'returnObject.tellUsABitMore.yourEmailAddress': '=_input.email',
				'returnObject.tellUsABitMore.promotionalCode':
					'=_input.campaignCode',

				//property =================================================
				//lets get started -------------------------------------
				'returnObject.letsGetStarted.personOrCompany':
					'=_input.policyHolders.0.contact.contactType',
				'returnObject.letsGetStarted.startCoverDate':
					'=_input.periodStartDate',

				//tell us about the building -------------------------------------
				'returnObject.tellUsAboutTheBuilding.yearHomeBuilt':
					'=_input.dwellings.0.homeBuiltYear',
				'returnObject.tellUsAboutTheBuilding.isStrataRegdCorp':
					'=_input.dwellings.0.isStrataRegisteredBody',
				'returnObject.tellUsAboutTheBuilding.areUnitAboveBelow':
					'=_input.dwellings.0.isUnitsAvailable',
				'returnObject.tellUsAboutTheBuilding.corpInsureUnit':
					'=_input.dwellings.0.isOwnersInsureUnits',

				'returnObject.tellUsAboutTheBuilding.isSuburbanBlock':
					'=_input.dwellings.0.isSubUrbanLocated',
				'returnObject.tellUsAboutTheBuilding.isBlockLarger':
					'=_input.dwellings.0.isPropertySize',
				'returnObject.tellUsAboutTheBuilding.waterSource':
					'=_input.dwellings.0.waterSourced',
				'returnObject.tellUsAboutTheBuilding.waterTankCapacity':
					'=_input.dwellings.0.waterTankCapacity',
				'returnObject.tellUsAboutTheBuilding.isEmergencyFuelWaterTank':
					'=_input.dwellings.0.isSecondaryFitted',
				'returnObject.tellUsAboutTheBuilding.isBuildingRelocatable':
					'=_input.dwellings.0.isCaravanHomeLocated',
				'returnObject.tellUsAboutTheBuilding.areFoundationsSecured':
					'=_input.dwellings.0.isSecuredFoundation',
				'returnObject.tellUsAboutTheBuilding.isFixedPlumbingElectricityConnect':
					'=_input.dwellings.0.isPlumbingConnect',
				'returnObject.tellUsAboutTheBuilding.roofMake':
					'=_input.dwellings.0.roofMaterial',
				'returnObject.tellUsAboutTheBuilding.isHomeElevated':
					'=_input.dwellings.0.groundElevated',
				'returnObject.tellUsAboutTheBuilding.isPortionBelowGround':
					'=_input.dwellings.0.isPortionAboveGround',

				// 'returnObject.tellUsAboutTheBuilding.areContentsBelowGround':	'=_input.dwellings.0.',
				'returnObject.tellUsAboutTheBuilding.homeLevels':
					'=_input.dwellings.0.homeLevels',
				'returnObject.tellUsAboutTheBuilding.isNationalTrustListed':
					'=_input.dwellings.0.isNationalTrustListed',
				'returnObject.tellUsAboutTheBuilding.isHomeWired':
					'=_input.dwellings.0.isFullyRewired',

				//tell us about the security -------------------------------------
				'returnObject.tellUsAboutTheSecurity.security':
					'=_input.dwellings.0.locationSecurity',

				//rennovation and residents -------------------------------------
				'returnObject.renovationsAndResidents.isHomeUnderRepairs':
					'=_input.dwellings.0.isRenovated',

				//property usage -------------------------------------
				'returnObject.propertyUsage.isPropertyForBusiness':
					'=_input.dwellings.0.isIncomeGenerated',
				'returnObject.propertyUsage.propertyActivityDegree':
					'=_input.dwellings.0.incomeGeneratingDegree',

				'returnObject.propertyUsage.propertyActivities':
					'=_input.dwellings.0.incomeGeneratingActivities',
				'returnObject.propertyUsage.propertyAgricultureActivities':
					'=_input.dwellings.0.agriculturalActivities',

				//mortgage on property -------------------------------------
				'returnObject.mortgageOnProperty.propertyMortgagedWith':
					'=_input.dwellings.0.mortgagees',

				//building =================================================
				//building details -------------------------------
				'returnObject.buildingDetails.homeBuiltStandard':
					'=_input.dwellings.0.locationProperty.homeStandard',
				'returnObject.buildingDetails.landSlope':
					'=_input.dwellings.0.locationProperty.isLandSloped',
				'returnObject.buildingDetails.slopeType':
					'=_input.dwellings.0.locationProperty.slopeType',
				'returnObject.buildingDetails.homeTotalArea':
					'=_input.dwellings.0.locationProperty.knowHomeSize',
				'returnObject.buildingDetails.homeArea':
					'=_input.dwellings.0.locationProperty.sizeOfHome',
				'returnObject.buildingDetails.homeAreaUnit':
					'=_input.dwellings.0.locationProperty.areaUnit',
				'returnObject.buildingDetails.homeBedrooms':
					'=_input.dwellings.0.locationProperty.numberOfBedrooms',
				'returnObject.buildingDetails.homeBedroomSize':
					'=_input.dwellings.0.locationProperty.sizeOfBedroom',

				'returnObject.buildingDetails.homeDecks':
					'=_input.dwellings.0.locationProperty.numberOfBalconies',
				'returnObject.buildingDetails.homeVerandahs':
					'=_input.dwellings.0.locationProperty.numberOfVerandahs',
				'returnObject.buildingDetails.homeCarports':
					'=_input.dwellings.0.locationProperty.numberOfCarports',
				'returnObject.buildingDetails.homeGarages':
					'=_input.dwellings.0.locationProperty.numberOfGarages',

				'returnObject.buildingDetails.homeSheds':
					'=_input.dwellings.0.locationProperty.hasSheds',

				'returnObject.buildingDetails.largeSheds':
					'=_input.dwellings.0.locationProperty.numberOfLargeSheds',
				'returnObject.buildingDetails.smallSheds':
					'=_input.dwellings.0.locationProperty.numberOfSmallSheds',

				'returnObject.buildingDetails.homeFeatures.ducted_airconditioning':
					'=_input.dwellings.0.locationProperty.hasDuctedAirConditioning',
				'returnObject.buildingDetails.homeFeatures.in_ground_swimming_pool':
					'=_input.dwellings.0.locationProperty.hasInGroundPool',
				'returnObject.buildingDetails.homeFeatures.tennis_court':
					'=_input.dwellings.0.locationProperty.hasTennisCourt',
				'returnObject.buildingDetails.homeFeatures.granny_flat':
					'=_input.dwellings.0.locationProperty.hasGrannyFlat',

				'returnObject.buildingDetails.grannyFlatSize':
					'=_input.dwellings.0.locationProperty.grannyFlatSize',
				'returnObject.buildingDetails.isBuiltToCycloneStandards':
					'=_input.dwellings.0.isCycloneStandardlyBuilt',

				//covers =================================================
				//your buildings -------------------------------------
				'returnObject.yourBuilding.buildingSumInsured':
					'=_input.dwellings.0.buildingSumInsured',
				//your contents -------------------------------------
				'returnObject.yourContents.contentsSumInsured':
					'=_input.dwellings.0.contentSumInsured',
				//portable contents -------------------------------------
				'returnObject.portableContents.coverPortableContents':
					'=_input.dwellings.0.hasPortableContentsHomeAway',
				'returnObject.portableContents.coverPortableContentsRegion':
					'=_input.dwellings.0.portableCoverCountry',
				'returnObject.portableContents.coverPortableContentLimit':
					'=_input.dwellings.0.generalPortableContents',
				'returnObject.portableContents.portableContentsSpecifiedCover':
					'=_input.dwellings.0.hasSpecifiedPortableContList',

				//accidental loss or damage -------------------------------------
				'returnObject.accidentalLossOrDamage.coverAccDmgBuilding':
					'=_input.dwellings.0.policyOption.isBuildingAccidentalDamage',
				'returnObject.accidentalLossOrDamage.coverAccDmgContents':
					'=_input.dwellings.0.policyOption.isContentsAccidentalDamage',

				//cycle cover -------------------------------------
				'returnObject.cycleCover.coverCycle':
					'=_input.dwellings.0.policyOption.isContentsCycleCover',
				'returnObject.cycleCover.coverCycleExtendOption':
					'=_input.dwellings.0.policyOption.isContentsCycleRacingCover',
				'returnObject.cycleCover.cycleList':
					'=_input.dwellings.0.policyOption.cycles',
				'returnObject.cycleCover.coverItemsList':
					'=_input.dwellings.0.policyOption.cycleEquipments',

				//rent default
				'returnObject.rentDefault.rentDefault':
					'=_input.dwellings.0.policyOption.rentDefaultAmount',

				'returnObject.rentDefault.rentCurrentWeekly':
					'=_input.dwellings.0.policyOption.rentDefaultAmount',
				'returnObject.rentDefault.rentXWeeks':
					'=_input.dwellings.0.policyOption.rentDefaultWeeks',

				//vandalism by tenanats
				'returnObject.theftAndVandalismByTenants.theftCoverContents':
					'=_input.dwellings.0.policyOption.isContentVandalismCover',
				'returnObject.theftAndVandalismByTenants.theftCoverBuilding':
					'=_input.dwellings.0.policyOption.isBuildingVandalismCover',
				// 'returnObject.tellUsHowWeCanInsureYou.coverNeeds.malicious_damage':	'=_input.dwellings.0.isBuildingVandalismCover',

				//high risk items
				'returnObject.specifiedHighRiskItems.riskCoverIndividualWorks':
					'=_input.dwellings.0.hasWorksArt',
				'returnObject.specifiedHighRiskItems.riskEntertainmentEquipment':
					'=_input.dwellings.0.hasEntertainmentEquipment',

				//domestic worker compansation
				'returnObject.domesticWorkerCompensation.domesticWorkerCompCover':
					'=_input.dwellings.0.policyOption.isContentsDomesticWorkerComp',

				//details =================================================
				//tell us about insured -------------------------------------
				'returnObject.tellUsAboutInsured.dobOldestInsured':
					'=_input.policyHolders.0.contact.dateOfBirth',
				'returnObject.tellUsAboutInsured.isRetired':
					'=_input.isInsuredsRetired',

				// insurance history -------------------------------------
				'returnObject.insuranceHistory.history':
					'=_input.dwellings.0.dwellingHistories',
				'returnObject.insuranceHistory.insuranceHeldFor':
					'=_input.dwellings.0.yearsContInsurance',
				'returnObject.insuranceHistory.previousInsurer':
					'=_input.dwellings.0.previousInsurer',
				'returnObject.insuranceHistory.claimInLastYear':
					'=_input.dwellings.0.hasInsuredClaims',
				'returnObject.insuranceHistory.portableClaim':
					'=_input.hasPortableContentsClaims',

				//quote =================================================
				//insured excess value -------------------------------------
				//save on premium -------------------------------------
				// optional benifits -------------------------------------
				// promotonal code -------------------------------------

				//contact =================================================
				//tell us about the main policy holder -------------------------------------
				//main policy holder contact -------------------------------------
				//additional policy holder -------------------------------------
				//tell us about the company -------------------------------------
				//tell us about the authurised contact for the company -------------------------------------
				//compant contact -------------------------------------
				'returnObject.policyHolders': '=_input.policyHolders',

				//payment =================================================
				//payment details -------------------------------------
				//promotional code -------------------------------------

				//additional info
				'returnObject.info': {},
				'returnObject.info.offering': '=_input.dwellings.0.offering'
			},
			convertMapping = {
				'returnObject.letsGetStarted.startCoverDate': transformers.date,
				'returnObject.buildingDetails.homeBedrooms':
					transformers.itemCount,
				'returnObject.buildingDetails.homeDecks':
					transformers.itemCount,
				'returnObject.buildingDetails.homeVerandahs':
					transformers.itemCount,
				'returnObject.buildingDetails.homeCarports':
					transformers.itemCountCarPort,
				'returnObject.buildingDetails.homeGarages':
					transformers.itemCountGarages,
				'returnObject.buildingDetails.largeSheds':
					transformers.itemCount,
				'returnObject.buildingDetails.smallSheds':
					transformers.itemCount,
				'returnObject.rentDefault.rentDefault': transformers.hasValue,
				'returnObject.tellUsAboutTheBuilding.isPortionBelowGround':
					transformers.yesNo,
				'returnObject.tellUsAboutInsured.isRetired': transformers.yesNo,
				'returnObject.tellUsAboutTheBuilding.isBuiltToCycloneStandards':
					transformers.yesNo

				// 'returnObject.carDetails.colour':									   transformers.camelcase,
				// 'returnObject.getStarted.policyStartDate':							  transformers.date,
				// 'returnObject.carDetails.carFinance':									transformers.financeType,
				// 'returnObject.retrievedQuoteRego.state':								transformers.state,
				// 'returnObject.insuredExcessValue.coverType':							transformers.coverType,
				// 'returnObject.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft':   transformers.thirdPartyPref,
				// 'returnObject.carDetails.whenDidYouBuyYear':							transformers.purchaseMonthFromMonthYear,
				// 'returnObject.carDetails.whenDidYouBuyMonth':						   transformers.purchaseYearFromMonthYear
			};
		var transformedQuote = jsonMapper.convert(
			jsonMapper.transform(retrievedQuoteResponse, transformMapping),
			convertMapping
		);
		transformedQuote.returnObject.tellUsAboutTheSecurity = transformSecurity(
			transformedQuote.returnObject.tellUsAboutTheSecurity
		);
		transformedQuote.returnObject.tellUsHowWeCanInsureYou = transformNeeds(
			transformedQuote.returnObject.tellUsHowWeCanInsureYou,
			transformedQuote.returnObject
		);
		transformedQuote.returnObject.buildingDetails = transformBuilding(
			transformedQuote.returnObject.buildingDetails
		);
		transformedQuote.returnObject.tellUsAboutTheBuilding = transformTellUsAboutBuilding(
			transformedQuote.returnObject.tellUsAboutTheBuilding
		);
		transformedQuote.returnObject.mortgageOnProperty = transformMortgageOnProperty(
			transformedQuote.returnObject.mortgageOnProperty
		);
		transformedQuote.returnObject.cycleCover = transformCycleCover(
			transformedQuote.returnObject.cycleCover
		);
		transformedQuote.returnObject.insuranceHistory = transformInsuranceHistory(
			transformedQuote.returnObject.insuranceHistory
		);
		transformedQuote.returnObject = transformPolicyHolders(
			transformedQuote.returnObject,
			retrievedQuoteResponse
		);

		return transformedQuote.returnObject;
	}
	return {
		transform: transform
	};
}
